import { TICKET_LIST, TICKET_REPLY, CREATE_TICKET, CATEGORY_LIST, QUESTION_LIST } from 'App/store/constants';
const initialState = {
  tickets: [],
  replies: null,
  reply: null,
  selectedTicket: null,
  categories: null,
  questions: null,
  errors: {},
  loading: false,
};


const reducer = (state = initialState, action: any) => {
  if (!action || !action.type) {
    console.error('Invalid action dispatched', action);
    return state;
  }

  switch (action.type) {
    case TICKET_LIST.PENDING:
      return { ...state, loading: true };
    case TICKET_LIST.SUCCESS:
      return { ...state, loading: false, tickets: action.payload.data };
    // Keep the previously-loaded tickets on failure so a transient error
    // doesn't blank out the rider's history; just surface the error.
    case TICKET_LIST.FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };

    // PENDING leaves replies in place — clearing them mid-fetch causes a
    // jarring flash when reopening the same ticket.
    case TICKET_REPLY.PENDING:
      return { ...state, loading: true };
    // sendReply also dispatches TICKET_REPLY but its payload has no `data`
    // (just status/msg). Only update replies when the payload actually
    // carries an array.
    case TICKET_REPLY.SUCCESS: {
      const next = action.payload?.data;
      if (Array.isArray(next)) {
        return { ...state, loading: false, replies: next };
      }
      return { ...state, loading: false };
    }
    case TICKET_REPLY.FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };

    case CREATE_TICKET.PENDING:
      return { ...state, loading: true };
    // Don't overwrite the tickets array here — create returns a single
    // record, not the list. The caller dispatches loadTickets() right
    // after a successful create to refresh the list.
    case CREATE_TICKET.SUCCESS:
      return { ...state, loading: false };
    case CREATE_TICKET.FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };

    case CATEGORY_LIST.PENDING:
      return { ...state, loading: true };
    case CATEGORY_LIST.SUCCESS:
      return { ...state, loading: false, categories: action.payload.data };
    case CATEGORY_LIST.FAILURE:
      return {
        ...state,
        categories: [],
        loading: false,
        errors: action.payload,
      };

    case QUESTION_LIST.PENDING:
      return { ...state, loading: true };
    case QUESTION_LIST.SUCCESS:
      return { ...state, loading: false, questions: action.payload.data };
    case QUESTION_LIST.FAILURE:
      return {
        ...state,
        questions: [],
        loading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
